var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie-conatiner"},_vm._l((_vm.dataMap),function(item,index){return _c('div',{key:index,staticClass:"pie",attrs:{"id":("myChart-" + (item.title))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }